if(!customElements.get('flip-carousel')) {

    class ComponentProductIngredients extends HTMLElement {
      constructor() {
        super()

        this.sliderElement = this.querySelector('.keen-slider');
        this.carouselMode = this.dataset.carouselMode;
        this.carouselLoop = this.dataset.carouselLoop;
        this.carouselAutoplay = this.dataset.carouselAutoplay;
        this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
        this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
        this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
        this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
        this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
        this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
        this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
        this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
        this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

        this.paginateCurrent = this.querySelector('.current');
        this.paginateLength = this.querySelector('.length');

        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);

      }

      handleMediaChange(){
        if($s.media.isLarge && this.currentMediaSize != 'large') {
          this.currentMediaSize = 'large';
          this.largeTarget.appendChild(this.galleryToMove);
          if(this.sliderObj)
            this.sliderObj.destroy();
          this.initSlider();
        }
        if($s.media.isMediumDown && this.currentMediaSize != 'medium') {
          this.currentMediaSize = 'medium';
          this.mediumTarget.appendChild(this.galleryToMove);
          if(this.sliderObj)
            this.sliderObj.destroy();
          this.initSlider();
        }
      }

      initSlider() {
        this.sliderObj = new KeenSlider(this.sliderElement, {
          mode: this.carouselMode,
          loop: this.carouselLoop=="true",
          dots: this.querySelector('.keen-dots'),
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          slideCounter: this.querySelector('.paginate'),
          autoplay: this.carouselAutoplay,
          slideChanged: (keen)=>{
            var slides = keen.slides();
          },
          breakpoints: {
            '(min-width: 1051px)': {
              centered: this.carouselCenteredDesktop=="true",
              spacing: this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 601px) and (max-width: 1050px)': {
              centered: this.carouselCenteredTablet=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet
            },
            '(max-width: 600px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile
            }
          }
        });
      }

    }
    customElements.define('flip-carousel', ComponentProductIngredients);

  }
